import React from 'react';
import { filterProps, slottedToComponents } from '../helpers';
import { Props } from '../types';

export const RocheAccordionTabs = ({ blok, getComponent, slot }: Props): JSX.Element => {
  const { props, slotted } = filterProps(blok);

  const startPosition = parseInt(props['start-position'], 10);
  props['start-position'] = Number.isNaN(startPosition) ? '' : `${Math.max(startPosition - 1, 0)}`;

  return <roche-accordion-tabs {...props} slot={slot}>
    {slottedToComponents(getComponent, slotted)}
  </roche-accordion-tabs>;
};
